module.exports = __webpack_public_path__ + "img/logo.e3eb9e9d.svg";